import Axios from 'axios';
import store from '@/store';

export const sendUsername = userName => Axios.post('accounts/login', { userName });

export const auth = (password, guid) => Axios.post('accounts/password', { password, guid });

export const getToken = () => localStorage.getItem(store.getters['authentication/getConfig'].VUE_APP_TOKEN_KEY);

export const logoff = () => Axios.post('Accounts/logoff', { accessToken: getToken() });

export const getProfile = () => Axios.get('accounts/profile');

export const sendEmailForgotPassword = email => Axios.post('accounts/profile/sendEmailChangePassword', { email });

export const editPassword = (newPassword, newPasswordConfirmation) =>
  Axios.put('accounts/profile/changePassword', {
    newPassword,
    newPasswordConfirmation
  });

export const getAcceptTerms = () => Axios.get('accounts/profile/acceptTerms');

export const confirmAcceptTerms = () => Axios.post('accounts/profile/confirmAcceptTerms');

export const getRulesPassword = () => Axios.get(`administration/settingsApplication/getRulesPassword`);

export const changeParameter = (id, codParameter, valueParam) =>
  Axios.put('administration/settingsApplication/changeParameter', {
    id,
    codParameter,
    valueParam
  });

export const getShowCaptcha = userName => Axios.post(`administration/settingsApplication/getShowCaptcha`, { userName });

export const getApiUrl = () => Axios.get(`${window.location.origin}${window.location.pathname}config/config.json`);
